import { ReactElement, memo } from 'react';
import { MenuItem } from '@mui/material';

import AccessFeature from '../../AccessFeature';

import { SelectWithScopeFieldMenuItemProps } from './types';

const SelectWithScopeFieldMenuItem = ({
  validSubscriptionFeature,
  ...restProps
}: SelectWithScopeFieldMenuItemProps): ReactElement => {
  if (validSubscriptionFeature) {
    return (
      <AccessFeature.MenuItem
        {...validSubscriptionFeature}
        {...restProps}
        disableTypography
      />
    );
  }

  return <MenuItem {...restProps} />;
};

export default memo(SelectWithScopeFieldMenuItem);
